<script>
  import { onMount } from 'svelte';
  import { fade } from 'svelte/transition';

  import Input from './formcomponents/Input.svelte';
  import Select from './formcomponents/Select.svelte';
  import Textarea from './formcomponents/Textarea.svelte';
  // import Checkbox from './formcomponents/Checkbox.svelte';
  import FormFieldGroup from './formcomponents/FormFieldGroup.svelte';
  import FormActions from './formcomponents/FormActions.svelte';
  import ModalDialogues from './ModalDialogues.svelte';
  import Spinner from './_Spinner.svelte';
  import MailToLink from './lib/MailToLink.svelte';

  import { postContact } from './lib/postContact';
  import { MDContactSuccess, MDServerError } from './lib/modaldialogues';
  import { InputRegexPatterns } from './constants/input_regex_patterns';

  let theForm;

  let contactForm = {
    company: '',
    email: '',
    firstname: '',
    lastname: '',
    message: '',
    phone: '',
    region: document.body.dataset.region || null,
    topic: '',
    // tosAccepted: null,
  };

  const iterateFields = function* (formReference) {
    for (let field of formReference.elements) {
      if (
        field instanceof HTMLInputElement ||
        field instanceof HTMLSelectElement ||
        field instanceof HTMLTextAreaElement
      )
        yield field;
    }
  };

  function clearFormStorage() {
    for (const field of iterateFields(theForm)) {
      sessionStorage.removeItem(`${theForm.name}__${field.name}`);
    }
  }

  function initForm() {
    for (const field of iterateFields(theForm)) {
      const stored_field = `${theForm.name}__${field.name}`;
      const stored_value = sessionStorage.getItem(stored_field);

      if (stored_value === null && contactForm[field.name] !== null) {
        sessionStorage.setItem(stored_field, contactForm[field.name]);
      } else {
        if (field.type === 'checkbox') {
          contactForm[field.name] = stored_value === 'true' ? true : false;
        } else {
          contactForm[field.name] = stored_value;
        }
      }
    }
  }

  async function onSubmit() {
    const payload = Object.fromEntries(new FormData(theForm));
    // payload.tosAccepted = theForm.tosAccepted.value === 'on' ? true : false;
    console.table(payload);

    try {
      await postContact(payload);
      // on success:
      theForm.reset();
      clearFormStorage();
      MDContactSuccess();
    } catch (e) {
      console.error(e);
      MDServerError();
    }
  }

  onMount(() => {
    theForm = document.forms['contact'];
    initForm();
  });
</script>

<ModalDialogues />
<Spinner />
<section name="commoncontact" in:fade={{ duration: 350 }}>
  <form
    autocomplete="on"
    name="contact"
    id="contact"
    on:submit|preventDefault={onSubmit}
  >
    <input type="hidden" name="region" bind:value={contactForm.region} />
    <fieldset>
      <legend>Kontakt</legend>

      <p class="description">
        <b>Schön, dass Sie sich für den regionalen Strommarkt interessieren!</b
        ><br />
        Sie haben Fragen oder Anmerkungen? – Gerne helfen wir Ihnen mit Ihrem Anliegen.
      </p>

      <FormFieldGroup>
        <Input
          name="firstname"
          bind:value={contactForm.firstname}
          label="Vorname"
          spellcheck="false"
          autocomplete="given-name"
          autocorrect="off"
          min="3"
          max="255"
          data-invalid_message="Bitte tragen Sie hier Ihren Vornamen ein."
          errormessage="Bitte tragen Sie hier Ihren Vornamen ein."
          required={true}
        />
        <Input
          name="lastname"
          bind:value={contactForm.lastname}
          label="Nachname"
          spellcheck="false"
          autocomplete="family-name"
          autocorrect="off"
          min="3"
          max="255"
          data-invalid_message="Bitte tragen Sie hier Ihren Nachnamen ein."
          errormessage="Bitte tragen Sie hier Ihren Nachnamen ein."
          required={true}
        />
        <Input
          type="email"
          name="email"
          bind:value={contactForm.email}
          label="E-Mail-Adresse"
          spellcheck="false"
          autocomplete="email"
          inputmode="email"
          autocorrect="off"
          data-invalid_message="Bitte tragen Sie hier Ihre (gültige) E-Mail-Adresse ein, damit wir Ihnen antworten können."
          errormessage="Bitte tragen Sie hier Ihre (gültige) E-Mail-Adresse ein, damit wir Ihnen antworten können."
          required={true}
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <Input
          name="company"
          bind:value={contactForm.company}
          label="Firma"
          spellcheck="true"
          autocorrect="off"
          data-invalid_message="Bitte tragen Sie hier einen gültigen Firmennamen ein, oder lassen Sie das Feld frei …"
          errormessage="Bitte tragen Sie hier einen gültigen Firmennamen ein, oder lassen Sie das Feld frei …"
          required={false}
        />
        <Input
          name="phone"
          type="tel"
          bind:value={contactForm.phone}
          label="Telefonnummer"
          spellcheck="true"
          autocomplete="tel"
          inputmode="tel"
          autocorrect="off"
          pattern={InputRegexPatterns.PHONE_NUMBER}
          data-invalid_message="Bitte tragen Sie hier eine gültige Telefonnummer ein, oder lassen Sie das Feld frei …"
          errormessage="Bitte tragen Sie hier eine gültige Telefonnummer ein, oder lassen Sie das Feld frei …"
          required={false}
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <Select
          name="topic"
          bind:value={contactForm.topic}
          label="Um welches Thema geht es?"
          data-invalid_message="Bitte wählen Sie ein Thema aus."
          errormessage="Bitte wählen Sie ein Thema aus."
          required={true}
        >
          <option value={'Ich bin Interessent und habe allgemeine Fragen'}
            >Ich bin Interessent und habe allgemeine Fragen.</option
          >
          <option value={'Frage zur Rechnung'}
            >Ich habe eine Frage zur Rechnung.</option
          >
          <option value={'Umzug'}>Ich ziehe um.</option>
          <option value={'Beschwerde'}>Ich habe eine Beschwerde.</option>
          <option value={'Sonstiges'}>Sonstiges.</option>
        </Select>
      </FormFieldGroup>

      <Textarea
        bind:value={contactForm.message}
        label="Mitteilung"
        spellcheck="true"
        autocorrect="on"
        name="message"
        cols="30"
        rows="8"
        maxlength="2500"
        data-invalid_message="Bitte schildern Sie uns Ihr Anliegen."
        errormessage="Bitte schildern Sie uns Ihr Anliegen."
        required={true}
      />

      <p class="info">
        Informationen zur Datenverarbeitung können Sie unserer <a
          href="https://www.bayernwerk-regio-energie.de/datenschutz"
          >Datenschutzerklärung</a
        > entnehmen.
      </p>

      <!-- <Checkbox
        required={true}
        name="tosAccepted"
        id="tos"
        label="Ich habe die Datenschutzerklärung zur Kenntnis genommen. Ich stimme zu, dass meine Angaben und Daten zur Beantwortung meiner Anfrage elektronisch erhoben und gespeichert werden."
        bind:checked={contactForm.tosAccepted}
      /> -->

      <FormActions>
        <button id="submit" type="submit" class="neutral">Anfrage senden</button>
      </FormActions>
    </fieldset>
  </form>
</section>
